import { Money20 } from '@carbon/icons-react';
import React from 'react';
import { AccountStatus } from 'api/account';
import { PageLoading } from 'components/atoms/loading';
import { Helium } from 'components/templates';
import { useAccount, useIsAccountActive } from 'hooks/use-account';
import { useTranslation } from 'hooks/use-translation';
import { useSubscriptionQuery } from 'queries/billing';
import { logger } from 'services';
import { ActiveSubscriptionSettings } from './active-subscription';
import { TrialSubscriptionSettings } from './trial-subscription';

const SettingsContent = () => {
  const { status: accountStatus } = useAccount();
  const isAccountActive = useIsAccountActive();
  const { data: subscription, isLoading } = useSubscriptionQuery(true);

  if (isLoading || !subscription || !subscription.subscriptionMeta) {
    return <PageLoading css />;
  }
  switch (accountStatus) {
    case AccountStatus.Trial:
      return <TrialSubscriptionSettings subscription={subscription} />;

    case AccountStatus.Active:
    case AccountStatus.Paid:
    case AccountStatus.Grace:
    case AccountStatus.Suspended:
      return (
        <ActiveSubscriptionSettings
          subscription={subscription}
          isExpired={!isAccountActive}
        />
      );

    default:
      logger.warn(`Unknown account status: ${accountStatus}`);

      return <></>;
  }
};

export const BillingSettings = () => {
  const title = useTranslation('settings.billing.title');

  return (
    <Helium icon={<Money20 />} documentTitle={title}>
      <SettingsContent />
    </Helium>
  );
};
